import { render, staticRenderFns } from "./Zona.vue?vue&type=template&id=1ebc0bb7"
import script from "./Zona.vue?vue&type=script&lang=js"
export * from "./Zona.vue?vue&type=script&lang=js"
import style0 from "./Zona.vue?vue&type=style&index=0&id=1ebc0bb7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports